import { SortedCountries, Countries } from './constants';
export var extractNumbersAndStripLeadingZeros = function (input) {
    var _a, _b;
    return ((_b = (_a = input === null || input === void 0 ? void 0 : input.match(/\d/g)) === null || _a === void 0 ? void 0 : _a.join('')) === null || _b === void 0 ? void 0 : _b.replace(/^0+/, '')) || '';
};
export var findCountryByPhone = function (input, lastSelectedCountry) {
    if (!input)
        return lastSelectedCountry || Countries.INT;
    var phoneValue = extractNumbersAndStripLeadingZeros(input);
    var countryMatch;
    SortedCountries.forEach(function (country) {
        if (phoneValue.startsWith(country.countryPhoneCode) &&
            (!countryMatch ||
                countryMatch.countryPhoneCode.length < country.countryPhoneCode.length)) {
            countryMatch = country;
        }
    });
    if (countryMatch &&
        lastSelectedCountry &&
        countryMatch.countryPhoneCode === lastSelectedCountry.countryPhoneCode) {
        return lastSelectedCountry;
    }
    return countryMatch || Countries.INT;
};
export var getPhoneValues = function (value, lastSelectedCountry) {
    var phoneValue = extractNumbersAndStripLeadingZeros(value);
    var selectedCountry = findCountryByPhone(phoneValue, lastSelectedCountry);
    var localPhoneNumber = phoneValue.replace(selectedCountry.countryPhoneCode, '');
    return {
        countryPhoneCode: "+" + selectedCountry.countryPhoneCode,
        localPhoneNumber: localPhoneNumber,
        selectedCountry: selectedCountry,
    };
};
export var phoneNumberFormatter = function (_a) {
    var _b = _a.countryPhoneCode, countryPhoneCode = _b === void 0 ? '' : _b, _c = _a.localPhoneNumber, localPhoneNumber = _c === void 0 ? '' : _c;
    return countryPhoneCode.length >= 2 && localPhoneNumber
        ? countryPhoneCode + " " + localPhoneNumber
        : "" + countryPhoneCode + localPhoneNumber;
};
export var filterCountriesBySearchString = function (searchString, countries) {
    var searchLowerCased = searchString.toLowerCase();
    var filteredCountries = countries.filter(function (_a) {
        var name = _a.name, countryCode = _a.countryCode, countryPhoneCode = _a.countryPhoneCode;
        return name.toLowerCase().includes(searchLowerCased) ||
            countryCode.toLowerCase().includes(searchLowerCased) ||
            countryPhoneCode.includes(searchLowerCased);
    });
    return filteredCountries;
};
export var isValidKeyEvent = function (e) {
    return /^[a-zA-Z0-9 ]$/.test(e.key);
};
//# sourceMappingURL=utils.js.map